import { IDeleteBancoPagamentoByIdUseCase } from "../../../presentation/useCases/delete/delete_banco_pagamento_by_id_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteBancoPagamentoByIdUseCase
 */

export class DeleteBancoPagamentoByIdUseCase implements IDeleteBancoPagamentoByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteBancoPagamentoById(idBancoPagamento: number): Promise<void> {
    await this.repository.deleteBancoPagamentoById(idBancoPagamento);

  }
}
